/**
 * Утилиты для строк фильтра отчётов (формат `field=value^field2=value2`)
 */
export class FilterHelper {
    // В проекте хэш встречается и в одинарной кодировке (старые ссылки), и в двойной
    // (report.dashboard.twig:135) — на бэкенде разницу съедает urldecode в Parser::parse()
    // (src/Repositories/Filter/Parser.php:61). Раскодируем до упора, но не больше двух раз,
    // чтобы не разобрать значение, в котором проценты часть самих данных.
    static DECODE_ATTEMPTS = 2;

    /**
     * Приводит строку фильтра к раскодированному виду независимо от конвенции кодирования
     * @param value {String}
     * @returns {String}
     */
    static decode(value) {
        let result = value ? String(value) : '';

        for (let i = 0; i < FilterHelper.DECODE_ATTEMPTS && /%[0-9a-f]{2}/i.test(result); i++) {
            try {
                result = decodeURIComponent(result);
            } catch (e) {
                break;
            }
        }

        return result;
    }

    /**
     * Кодирует строку фильтра для хэша так, как его пишет сайт, — дважды: панель фильтра раскодирует хэш дважды,
     * таблица — один раз (второй раз — разбор фильтра на бэкенде). При одинарной кодировке «%» в значении
     * (анкор «Скидка -65%», адрес с %-кодами) ломает разбор
     * @param value {String}
     * @returns {String}
     */
    static encode(value) {
        return encodeURIComponent(encodeURIComponent(value));
    }

    /**
     * Имя поля условия: 'status=1' -> 'status'
     * @param filter {String}
     * @returns {String}
     */
    static fieldName(filter) {
        return FilterHelper.decode(filter).split('=')[0];
    }

    /**
     * Состоит ли фильтр только из условий по указанному полю.
     *
     * Повторяет проверку бэкенда (api/Middleware/LinksDemoFilters.php:25-36): имя берётся
     * до первого '=', префикс OR намеренно не срезается — на 'ORstatus' бэкенд тоже
     * отвечает 403, и расходиться с ним здесь нельзя.
     *
     * @param filter {String}
     * @param field {String}
     * @returns {Boolean}
     */
    static hasOnlyField(filter, field) {
        if (!field) {
            return false;
        }

        const parts = FilterHelper.decode(filter).split('^').filter(Boolean);

        return parts.length > 0 && parts.every(part => part.split('=')[0] === field);
    }
}
